export const PRIVACY_EN = {
  title: "Privacy Policy",
  version: "1.1",
  updated: "2026-06-15",
  intro:
    "This policy explains what data HELCOO collects, why, how we protect it, and your rights. It applies to our website and our iOS and Android apps. Privacy contact: support@helcoo.uk.",
  sections: [
    {
      h: "1. Data we collect",
      p: [
        "Account data: name, email, phone, physical (home) address — optional, entered by the employer or the employee — nationality, date of birth, marital status, emergency contact name and number, company, branch and job role.",
        "Financial data: bank account number (IBAN), salary, deductions and bonuses — used for payroll only.",
        "Biometric data: a live face image and a derived digital face template. At enrolment the image is sent to AWS Rekognition, which creates the template and stores it in our private collection (IndexFaces); we keep only the template id and the reference image. At every check-in/out the live frame is sent to Rekognition for comparison (CompareFaces/SearchFaces) and then deleted immediately. Used solely to verify the employee's identity.",
        "Precise location: read only at the moment of a check-in or check-out, to confirm presence within the branch geofence.",
        "Attendance data: check-in/out times, lateness, overtime and leave.",
        "Device and usage data (collected in server logs only): IP address and the country/city derived from it, device/browser type, request path, response code, response time linked to your account, and technical error messages. Plus your device push token (FCM) and OS type, used solely to deliver notifications.",
        "The app contains no third-party behavioural analytics or crash-reporting SDK (no Crashlytics, no Sentry, no Google Analytics) and collects no advertising identifier.",
        "Documents and files: national ID, passport, contracts, and medical certificates uploaded by the employee for sick-leave requests (health data), plus company accounting documents.",
      ],
    },
    {
      h: "1.1 Medical certificates and health data",
      p: [
        "When you request sick leave you may be asked for a medical certificate (image or PDF, max 2 MB). It is used solely to decide the request and to calculate leave balance and payroll. It is never used for any other purpose, never shared with third parties and never sent to any AI model.",
        "It is stored encrypted in your company's object storage (Amazon S3) under a company-scoped path. Access is limited to the employee, the HR manager, the company admin and the direct manager approving the request. Every access is logged.",
        "It is retained for as long as the related leave record exists (an employment record that local law may require) and is erased when your account is deleted or the subscription ends. The app never asks you for a diagnosis or medical details.",
      ],
    },
    {
      h: "2. Legal basis and consent",
      p: ["We process data to perform our contract with the subscribing company, for legitimate interests in system security, and to meet legal obligations. Biometric data is processed only with the employee's explicit, separate consent, which may be withdrawn at any time."],
    },
    {
      h: "3. How we use data",
      p: ["To verify employee identity at attendance events, prevent fraud, calculate payroll and reports, send operational notifications, and improve the reliability and security of the Service."],
    },
    {
      h: "4. What we never do",
      p: ["We do not sell your data. We never use biometric or location data for advertising, marketing or cross-app tracking. We do not use your data to train third-party face recognition systems. We do not track location in the background."],
    },
    {
      h: "5. Service providers",
      p: ["We use processors bound by data processing agreements: Amazon Web Services (S3 storage, Rekognition face matching, SES email delivery) and Stripe for payment processing. They may not use your data for their own purposes."],
    },
    {
      h: "6. International transfers",
      p: ["Data may be stored in data centres in the European Union and the United States, with appropriate contractual safeguards for international transfers."],
    },
    {
      h: "7. Retention and deletion",
      p: [
        "Attendance records are retained for the subscription term and as required by local regulation. Face templates are deleted immediately when consent is withdrawn or the account is closed. After termination, data may be exported for 30 days and is then permanently deleted.",
        "To access, correct or delete your data and account, email support@helcoo.uk; we respond within 30 days.",
      ],
    },
    {
      h: "8. Security",
      p: ["HTTPS in transit, encryption at rest, hashed passwords, role-based access control, per-company data isolation, audit logs, and single-use recovery tokens."],
    },
    {
      h: "9. Your rights",
      p: ["You have the right to access, rectify, erase, object, restrict processing, port your data and withdraw consent, under GDPR, CCPA and equivalent laws. Exercising these rights will not result in discriminatory treatment."],
    },
    {
      h: "10. Children",
      p: ["The Service is intended for workplaces and is not directed at anyone under 16; we do not knowingly collect their data."],
    },
    {
      h: "11. Changes and contact",
      p: ["We will notify you of material changes to this policy before they take effect. Questions or privacy complaints: support@helcoo.uk."],
    },
  ],
};
